import styled from "styled-components";

export const SpacerAndDividerEditorContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: center;
  margin-bottom: 316px;
`;
